/* Never wider than what holds it: given less than its words, they end in an
   ellipsis. */
.tag {
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: var(--zumpo-space-6);
  max-width: 100%;
  padding: var(--zumpo-space-6) var(--zumpo-space-12);
  border-radius: var(--zumpo-radius-999);
  background: var(--zumpo-sand);
  color: var(--zumpo-ink);
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
  white-space: nowrap;
}

/* The words, cut short with the ellipsis. */
.text {
  overflow: hidden;
  min-width: 0;
  text-overflow: ellipsis;
}

.blue {
  background: var(--zumpo-blue);
}

.lime {
  background: var(--zumpo-lime);
}

.peach {
  background: var(--zumpo-peach);
}

.paper {
  background: var(--zumpo-paper);
}

.ink {
  background: var(--zumpo-ink);
  color: var(--zumpo-paper);
}

.compact {
  padding: var(--zumpo-space-1) var(--zumpo-space-8);
}
